module.exports = __webpack_public_path__ + "static/img/ciri.608bee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/ciri.png
// module id = joC/
// module chunks = 0